// aaho: using skeleton from fenrir because the mui one has some wierd transform
// that reduces the scale of the height of the skeleton and doesnt make the
// layout predictable
import { Skeleton } from '@rtkwlf/fenrir-react';

import { Stack } from '@packages/fenrir/components/stack';

export const SpidrLibraryPageLoading = () => {
  return (
    <Stack
      direction="column"
      flex="1"
      gap="var(--c3-space-5)"
      marginTop="var(--c3-space-6)"
      data-testid="spidr-library-loading"
    >
      <Stack direction="row" gap="var(--c3-space-4)">
        {new Array(4).fill(0).map((_, key) => {
          return (
            <Skeleton key={key} height="2.5rem" width="7rem" margin="zero" />
          );
        })}
      </Stack>
      <Skeleton flex={1} width="full" margin="zero" />
    </Stack>
  );
};
